






import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-export',

})
export default class IExport extends Vue {

  @Prop({type: [String], default: '#ffffff'}) protected color!: string

}

